import { render } from "./Profile.vue?vue&type=template&id=6583c2a6&scoped=true"
import script from "./Profile.vue?vue&type=script&lang=js"
export * from "./Profile.vue?vue&type=script&lang=js"

import "./Profile.vue?vue&type=style&index=0&id=6583c2a6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6583c2a6"]])

export default __exports__